module.exports = __webpack_public_path__ + "static/img/bkjbz3.214f438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/bkjbz3.png
// module id = 5ozg
// module chunks = 0